var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class FrontPage extends Component {
    constructor() {
        super('FrontPage', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.home .carousel').on('slide.bs.carousel', (event) => {
                $('.home .carousel-indicators').css('--highlight-color', $(event.relatedTarget).css('--background'));
            });
            $(window).on('resize', () => {
                this.computeDimensions();
            });
            setTimeout(() => {
                this.computeDimensions();
            }, 1000);
            this.computeDimensions();
            this.success();
        });
    }
    computeDimensions() {
        if ($(window).width() >= 992)
            return;
        let height = 0;
        const width = $('.carousel .home-block-image').eq(0).width();
        $('.carousel .home-block-image .ratio').each((image) => {
            const imageHeight = width * parseFloat(image.css('--bs-aspect-ratio')) / 100;
            if (imageHeight > height)
                height = imageHeight;
        });
        $('.home-block-image').css('--height', `${height + 12 + $('.component-header').height()}px`);
        height = 0;
        $('.home .carousel-item').addClass('active');
        $('.carousel .home-block .flex-grow-1').each((block) => {
            if (block.height() > height)
                height = block.height();
        });
        $('.home .carousel-item').removeClass('active').eq(0).addClass('active');
        $('.carousel .home-block .flex-grow-1').css('height', `${height}px`);
    }
}
